// extracted by mini-css-extract-plugin
export default {"logoutBtn":"LogoutButton_logoutBtn__+2yNn"};